<section class="panel">
  <h2>{{ 'product.title' | t }}</h2>
  <div class="section-nav">
    <button type="button" [class.active]="activeSection === 'PRODUCTS'" (click)="activeSection = 'PRODUCTS'">{{ 'product.section.products' | t }}</button>
    <button type="button" [class.active]="activeSection === 'COMPONENTS'" (click)="activeSection = 'COMPONENTS'">{{ 'product.section.components' | t }}</button>
    <button type="button" [class.active]="activeSection === 'STRUCTURES'" (click)="activeSection = 'STRUCTURES'">{{ 'product.section.structures' | t }}</button>
    <button type="button" [class.active]="activeSection === 'COMPATIBILITIES'" (click)="activeSection = 'COMPATIBILITIES'">{{ 'product.section.compatibilities' | t }}</button>
  </div>
</section>

<div class="content-stack">
  <ng-container *ngIf="activeSection === 'PRODUCTS'">
    <section class="panel">
      <div class="panel-head">
        <h2>{{ 'product.categories' | t }}</h2>
        <button
          type="button"
          class="secondary icon-button collapse-toggle"
          (click)="toggleCardCollapse('categories')"
          [attr.aria-label]="isCardCollapsed('categories') ? ('common.expand' | t) : ('common.collapse' | t)"
          [title]="isCardCollapsed('categories') ? ('common.expand' | t) : ('common.collapse' | t)"
        >
          {{ isCardCollapsed('categories') ? '+' : '-' }}
        </button>
      </div>
      <div *ngIf="!isCardCollapsed('categories')">
      <div class="grid three">
        <label>
          {{ 'product.code' | t }}
          <input [(ngModel)]="categoryForm.code" />
        </label>
        <label>
          {{ 'product.name' | t }}
          <input [(ngModel)]="categoryForm.name" />
        </label>
      </div>
      <div class="actions">
        <button type="button" (click)="saveCategory()" [disabled]="busy">{{ categoryForm.id ? ('product.updateCategory' | t) : ('product.createCategory' | t) }}</button>
        <button type="button" class="secondary" (click)="resetCategoryForm()" [disabled]="busy">{{ 'common.clear' | t }}</button>
      </div>

      <div class="table-toolbar">
        <label>
          {{ 'common.filter' | t }}
          <input [(ngModel)]="tableState.categories.query" (ngModelChange)="onFilterChanged('categories')" [placeholder]="'product.searchCategories' | t" />
        </label>
        <button type="button" class="secondary icon-button table-refresh" (click)="reloadData()" [disabled]="busy" [attr.aria-label]="'product.refresh.categories' | t" [title]="'product.refresh.categories' | t">&#10227;</button>
      </div>

      <table class="admin-table">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSort('categories', 'code')">{{ 'product.code' | t }}<span class="sort-indicator">{{ sortIndicator('categories', 'code') }}</span></th>
            <th class="sortable" (click)="toggleSort('categories', 'name')">{{ 'product.name' | t }}<span class="sort-indicator">{{ sortIndicator('categories', 'name') }}</span></th>
            <th class="action-col">{{ 'product.actions' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of pagedItems('categories')">
            <tr class="expandable-row" (click)="toggleRowExpansion('categories', item.id)">
              <td>{{ item.code }}</td>
              <td>{{ item.name }}</td>
              <td class="row-actions action-col">
                <button type="button" class="secondary icon-button" (click)="$event.stopPropagation(); editCategory(item)" [disabled]="busy" [attr.aria-label]="'common.edit' | t" [title]="'common.edit' | t">&#9998;</button>
                <button type="button" class="danger icon-button" (click)="$event.stopPropagation(); deleteCategory(item)" [disabled]="busy" [attr.aria-label]="'common.delete' | t" [title]="'common.delete' | t"><svg class="icon-svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9 3h6l1 2h5v2H3V5h5l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM7 9h2v9H7V9z"/></svg></button>
              </td>
            </tr>
            <tr class="detail-row" *ngIf="isRowExpanded('categories', item.id)">
              <td colspan="3">
                <div class="audit-grid">
                  <span>{{ 'common.audit.ct' | t }}: {{ formatAuditTimestamp(item.ct) }}</span>
                  <span>{{ 'common.audit.mt' | t }}: {{ formatAuditTimestamp(item.mt) }}</span>
                  <span>{{ 'common.audit.cu' | t }}: {{ item.cu || '-' }}</span>
                  <span>{{ 'common.audit.mu' | t }}: {{ item.mu || '-' }}</span>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!visibleCount('categories')">
            <td colspan="3">{{ 'product.noCategories' | t }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pager">
        <span>{{ 'common.page' | t:{ page: tableState.categories.page, total: totalPages('categories'), items: visibleCount('categories') } }}</span>
        <div class="pager-controls">
          <label class="pager-size">
            {{ 'common.pageSize' | t }}
            <select [ngModel]="tableState.categories.pageSize" (ngModelChange)="setPageSize('categories', $event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="20">20</option>
              <option [value]="50">50</option>
            </select>
          </label>
          <div class="row-actions">
            <button type="button" class="secondary" (click)="previousPage('categories')" [disabled]="visibleCount('categories') === 0 || tableState.categories.page <= 1">{{ 'common.previous' | t }}</button>
            <button type="button" class="secondary" (click)="nextPage('categories')" [disabled]="visibleCount('categories') === 0 || tableState.categories.page >= totalPages('categories')">{{ 'common.next' | t }}</button>
          </div>
        </div>
      </div>
      </div>
    </section>

    <section class="panel">
      <div class="panel-head">
        <h2>{{ 'product.products' | t }}</h2>
        <button
          type="button"
          class="secondary icon-button collapse-toggle"
          (click)="toggleCardCollapse('products')"
          [attr.aria-label]="isCardCollapsed('products') ? ('common.expand' | t) : ('common.collapse' | t)"
          [title]="isCardCollapsed('products') ? ('common.expand' | t) : ('common.collapse' | t)"
        >
          {{ isCardCollapsed('products') ? '+' : '-' }}
        </button>
      </div>
      <div *ngIf="!isCardCollapsed('products')">
      <div class="grid three">
        <label>
          {{ 'product.code' | t }}
          <input [(ngModel)]="productForm.code" />
        </label>
        <label>
          {{ 'product.name' | t }}
          <input [(ngModel)]="productForm.name" />
        </label>
        <label>
          {{ 'product.category' | t }}
          <select [(ngModel)]="productForm.categoryId">
            <option value="">{{ 'common.none' | t }}</option>
            <option *ngFor="let item of categories" [value]="item.id">{{ item.name }}</option>
          </select>
        </label>
      </div>
      <div class="actions">
        <button type="button" (click)="saveProduct()" [disabled]="busy">{{ productForm.id ? ('product.updateProduct' | t) : ('product.createProduct' | t) }}</button>
        <button type="button" class="secondary" (click)="resetProductForm()" [disabled]="busy">{{ 'common.clear' | t }}</button>
      </div>

      <div class="table-toolbar">
        <label>
          {{ 'common.filter' | t }}
          <input [(ngModel)]="tableState.products.query" (ngModelChange)="onFilterChanged('products')" [placeholder]="'product.searchProducts' | t" />
        </label>
        <label>
          {{ 'product.filter.category' | t }}
          <select [ngModel]="tableState.products.facet" (ngModelChange)="tableState.products.facet = $event; onFacetChanged('products')">
            <option value="">{{ 'common.all' | t }}</option>
            <option *ngFor="let item of categories" [value]="item.id">{{ item.name }}</option>
          </select>
        </label>
        <button type="button" class="secondary icon-button table-refresh" (click)="reloadData()" [disabled]="busy" [attr.aria-label]="'product.refresh.products' | t" [title]="'product.refresh.products' | t">&#10227;</button>
      </div>

      <table class="admin-table">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSort('products', 'categoryName')">{{ 'product.category' | t }}<span class="sort-indicator">{{ sortIndicator('products', 'categoryName') }}</span></th>
            <th class="sortable" (click)="toggleSort('products', 'code')">{{ 'product.code' | t }}<span class="sort-indicator">{{ sortIndicator('products', 'code') }}</span></th>
            <th class="sortable" (click)="toggleSort('products', 'name')">{{ 'product.name' | t }}<span class="sort-indicator">{{ sortIndicator('products', 'name') }}</span></th>
            <th class="action-col">{{ 'product.actions' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of pagedItems('products')">
            <tr class="expandable-row" (click)="toggleRowExpansion('products', item.id)">
              <td>{{ item.categoryName || '-' }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.name }}</td>
              <td class="row-actions action-col">
                <button type="button" class="secondary icon-button" (click)="$event.stopPropagation(); editProduct(item)" [disabled]="busy" [attr.aria-label]="'common.edit' | t" [title]="'common.edit' | t">&#9998;</button>
                <button type="button" class="danger icon-button" (click)="$event.stopPropagation(); deleteProduct(item)" [disabled]="busy" [attr.aria-label]="'common.delete' | t" [title]="'common.delete' | t"><svg class="icon-svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9 3h6l1 2h5v2H3V5h5l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM7 9h2v9H7V9z"/></svg></button>
              </td>
            </tr>
            <tr class="detail-row" *ngIf="isRowExpanded('products', item.id)">
              <td colspan="4">
                <div class="audit-grid">
                  <span>{{ 'common.audit.ct' | t }}: {{ formatAuditTimestamp(item.ct) }}</span>
                  <span>{{ 'common.audit.mt' | t }}: {{ formatAuditTimestamp(item.mt) }}</span>
                  <span>{{ 'common.audit.cu' | t }}: {{ item.cu || '-' }}</span>
                  <span>{{ 'common.audit.mu' | t }}: {{ item.mu || '-' }}</span>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!visibleCount('products')">
            <td colspan="4">{{ 'product.noProducts' | t }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pager">
        <span>{{ 'common.page' | t:{ page: tableState.products.page, total: totalPages('products'), items: visibleCount('products') } }}</span>
        <div class="pager-controls">
          <label class="pager-size">
            {{ 'common.pageSize' | t }}
            <select [ngModel]="tableState.products.pageSize" (ngModelChange)="setPageSize('products', $event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="20">20</option>
              <option [value]="50">50</option>
            </select>
          </label>
          <div class="row-actions">
            <button type="button" class="secondary" (click)="previousPage('products')" [disabled]="visibleCount('products') === 0 || tableState.products.page <= 1">{{ 'common.previous' | t }}</button>
            <button type="button" class="secondary" (click)="nextPage('products')" [disabled]="visibleCount('products') === 0 || tableState.products.page >= totalPages('products')">{{ 'common.next' | t }}</button>
          </div>
        </div>
      </div>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeSection === 'COMPONENTS'">
    <section class="panel">
      <div class="panel-head">
        <h2>{{ 'product.componentTypes' | t }}</h2>
        <button
          type="button"
          class="secondary icon-button collapse-toggle"
          (click)="toggleCardCollapse('componentTypes')"
          [attr.aria-label]="isCardCollapsed('componentTypes') ? ('common.expand' | t) : ('common.collapse' | t)"
          [title]="isCardCollapsed('componentTypes') ? ('common.expand' | t) : ('common.collapse' | t)"
        >
          {{ isCardCollapsed('componentTypes') ? '+' : '-' }}
        </button>
      </div>
      <div *ngIf="!isCardCollapsed('componentTypes')">
      <div class="grid three">
        <label>
          {{ 'product.code' | t }}
          <input [(ngModel)]="componentTypeForm.code" />
        </label>
        <label>
          {{ 'product.name' | t }}
          <input [(ngModel)]="componentTypeForm.name" />
        </label>
      </div>
      <div class="actions">
        <button type="button" (click)="saveComponentType()" [disabled]="busy">{{ componentTypeForm.id ? ('product.updateType' | t) : ('product.createType' | t) }}</button>
        <button type="button" class="secondary" (click)="resetComponentTypeForm()" [disabled]="busy">{{ 'common.clear' | t }}</button>
      </div>

      <div class="table-toolbar">
        <label>
          {{ 'common.filter' | t }}
          <input [(ngModel)]="tableState.componentTypes.query" (ngModelChange)="onFilterChanged('componentTypes')" [placeholder]="'product.searchComponentTypes' | t" />
        </label>
        <button type="button" class="secondary icon-button table-refresh" (click)="reloadData()" [disabled]="busy" [attr.aria-label]="'product.refresh.componentTypes' | t" [title]="'product.refresh.componentTypes' | t">&#10227;</button>
      </div>

      <table class="admin-table">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSort('componentTypes', 'code')">{{ 'product.code' | t }}<span class="sort-indicator">{{ sortIndicator('componentTypes', 'code') }}</span></th>
            <th class="sortable" (click)="toggleSort('componentTypes', 'name')">{{ 'product.name' | t }}<span class="sort-indicator">{{ sortIndicator('componentTypes', 'name') }}</span></th>
            <th class="action-col">{{ 'product.actions' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of pagedItems('componentTypes')">
            <tr class="expandable-row" (click)="toggleRowExpansion('componentTypes', item.id)">
              <td>{{ item.code }}</td>
              <td>{{ item.name }}</td>
              <td class="row-actions action-col">
                <button type="button" class="secondary icon-button" (click)="$event.stopPropagation(); editComponentType(item)" [disabled]="busy" [attr.aria-label]="'common.edit' | t" [title]="'common.edit' | t">&#9998;</button>
                <button type="button" class="danger icon-button" (click)="$event.stopPropagation(); deleteComponentType(item)" [disabled]="busy" [attr.aria-label]="'common.delete' | t" [title]="'common.delete' | t"><svg class="icon-svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9 3h6l1 2h5v2H3V5h5l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM7 9h2v9H7V9z"/></svg></button>
              </td>
            </tr>
            <tr class="detail-row" *ngIf="isRowExpanded('componentTypes', item.id)">
              <td colspan="3">
                <div class="audit-grid">
                  <span>{{ 'common.audit.ct' | t }}: {{ formatAuditTimestamp(item.ct) }}</span>
                  <span>{{ 'common.audit.mt' | t }}: {{ formatAuditTimestamp(item.mt) }}</span>
                  <span>{{ 'common.audit.cu' | t }}: {{ item.cu || '-' }}</span>
                  <span>{{ 'common.audit.mu' | t }}: {{ item.mu || '-' }}</span>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!visibleCount('componentTypes')">
            <td colspan="3">{{ 'product.noComponentTypes' | t }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pager">
        <span>{{ 'common.page' | t:{ page: tableState.componentTypes.page, total: totalPages('componentTypes'), items: visibleCount('componentTypes') } }}</span>
        <div class="pager-controls">
          <label class="pager-size">
            {{ 'common.pageSize' | t }}
            <select [ngModel]="tableState.componentTypes.pageSize" (ngModelChange)="setPageSize('componentTypes', $event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="20">20</option>
              <option [value]="50">50</option>
            </select>
          </label>
          <div class="row-actions">
            <button type="button" class="secondary" (click)="previousPage('componentTypes')" [disabled]="visibleCount('componentTypes') === 0 || tableState.componentTypes.page <= 1">{{ 'common.previous' | t }}</button>
            <button type="button" class="secondary" (click)="nextPage('componentTypes')" [disabled]="visibleCount('componentTypes') === 0 || tableState.componentTypes.page >= totalPages('componentTypes')">{{ 'common.next' | t }}</button>
          </div>
        </div>
      </div>
      </div>
    </section>

    <section class="panel">
      <div class="panel-head">
        <h2>{{ 'product.components' | t }}</h2>
        <button
          type="button"
          class="secondary icon-button collapse-toggle"
          (click)="toggleCardCollapse('components')"
          [attr.aria-label]="isCardCollapsed('components') ? ('common.expand' | t) : ('common.collapse' | t)"
          [title]="isCardCollapsed('components') ? ('common.expand' | t) : ('common.collapse' | t)"
        >
          {{ isCardCollapsed('components') ? '+' : '-' }}
        </button>
      </div>
      <div *ngIf="!isCardCollapsed('components')">
      <div class="grid two">
        <label>
          {{ 'product.type' | t }}
          <select [(ngModel)]="componentForm.componentTypeId">
            <option value="">{{ 'product.selectType' | t }}</option>
            <option *ngFor="let item of componentTypes" [value]="item.id">{{ item.name }}</option>
          </select>
        </label>
        <label>
          {{ 'product.code' | t }}
          <input [(ngModel)]="componentForm.code" />
        </label>
        <label>
          {{ 'product.name' | t }}
          <input [(ngModel)]="componentForm.name" />
        </label>
        <label>
          {{ 'product.description' | t }}
          <textarea rows="2" [(ngModel)]="componentForm.description"></textarea>
        </label>
      </div>
      <div class="actions">
        <button type="button" (click)="saveComponent()" [disabled]="busy">{{ componentForm.id ? ('product.updateComponent' | t) : ('product.createComponent' | t) }}</button>
        <button type="button" class="secondary" (click)="resetComponentForm()" [disabled]="busy">{{ 'common.clear' | t }}</button>
      </div>

      <div class="table-toolbar">
        <label>
          {{ 'common.filter' | t }}
          <input [(ngModel)]="tableState.components.query" (ngModelChange)="onFilterChanged('components')" [placeholder]="'product.searchComponents' | t" />
        </label>
        <label>
          {{ 'product.filter.type' | t }}
          <select [ngModel]="tableState.components.facet" (ngModelChange)="tableState.components.facet = $event; onFacetChanged('components')">
            <option value="">{{ 'common.all' | t }}</option>
            <option *ngFor="let item of componentTypes" [value]="item.id">{{ item.name }}</option>
          </select>
        </label>
        <button type="button" class="secondary icon-button table-refresh" (click)="reloadData()" [disabled]="busy" [attr.aria-label]="'product.refresh.components' | t" [title]="'product.refresh.components' | t">&#10227;</button>
      </div>

      <table class="admin-table">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSort('components', 'componentTypeName')">{{ 'product.type' | t }}<span class="sort-indicator">{{ sortIndicator('components', 'componentTypeName') }}</span></th>
            <th class="sortable" (click)="toggleSort('components', 'code')">{{ 'product.code' | t }}<span class="sort-indicator">{{ sortIndicator('components', 'code') }}</span></th>
            <th class="sortable" (click)="toggleSort('components', 'name')">{{ 'product.name' | t }}<span class="sort-indicator">{{ sortIndicator('components', 'name') }}</span></th>
            <th>{{ 'product.description' | t }}</th>
            <th class="action-col">{{ 'product.actions' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of pagedItems('components')">
            <tr class="expandable-row" (click)="toggleRowExpansion('components', item.id)">
              <td>{{ item.componentTypeName || '-' }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.description || '-' }}</td>
              <td class="row-actions action-col">
                <button type="button" class="secondary icon-button" (click)="$event.stopPropagation(); editComponent(item)" [disabled]="busy" [attr.aria-label]="'common.edit' | t" [title]="'common.edit' | t">&#9998;</button>
                <button type="button" class="danger icon-button" (click)="$event.stopPropagation(); deleteComponent(item)" [disabled]="busy" [attr.aria-label]="'common.delete' | t" [title]="'common.delete' | t"><svg class="icon-svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9 3h6l1 2h5v2H3V5h5l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM7 9h2v9H7V9z"/></svg></button>
              </td>
            </tr>
            <tr class="detail-row" *ngIf="isRowExpanded('components', item.id)">
              <td colspan="5">
                <div class="audit-grid">
                  <span>{{ 'common.audit.ct' | t }}: {{ formatAuditTimestamp(item.ct) }}</span>
                  <span>{{ 'common.audit.mt' | t }}: {{ formatAuditTimestamp(item.mt) }}</span>
                  <span>{{ 'common.audit.cu' | t }}: {{ item.cu || '-' }}</span>
                  <span>{{ 'common.audit.mu' | t }}: {{ item.mu || '-' }}</span>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!visibleCount('components')">
            <td colspan="5">{{ 'product.noComponents' | t }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pager">
        <span>{{ 'common.page' | t:{ page: tableState.components.page, total: totalPages('components'), items: visibleCount('components') } }}</span>
        <div class="pager-controls">
          <label class="pager-size">
            {{ 'common.pageSize' | t }}
            <select [ngModel]="tableState.components.pageSize" (ngModelChange)="setPageSize('components', $event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="20">20</option>
              <option [value]="50">50</option>
            </select>
          </label>
          <div class="row-actions">
            <button type="button" class="secondary" (click)="previousPage('components')" [disabled]="visibleCount('components') === 0 || tableState.components.page <= 1">{{ 'common.previous' | t }}</button>
            <button type="button" class="secondary" (click)="nextPage('components')" [disabled]="visibleCount('components') === 0 || tableState.components.page >= totalPages('components')">{{ 'common.next' | t }}</button>
          </div>
        </div>
      </div>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeSection === 'STRUCTURES'">
    <section class="panel">
      <div class="panel-head">
        <h2>{{ 'product.productStructure' | t }}</h2>
        <button
          type="button"
          class="secondary icon-button collapse-toggle"
          (click)="toggleCardCollapse('productStructures')"
          [attr.aria-label]="isCardCollapsed('productStructures') ? ('common.expand' | t) : ('common.collapse' | t)"
          [title]="isCardCollapsed('productStructures') ? ('common.expand' | t) : ('common.collapse' | t)"
        >
          {{ isCardCollapsed('productStructures') ? '+' : '-' }}
        </button>
      </div>
      <div *ngIf="!isCardCollapsed('productStructures')">
      <div class="grid three">
        <label>
          {{ 'product.product' | t }}
          <select [(ngModel)]="structureForm.productId">
            <option value="">{{ 'product.selectProduct' | t }}</option>
            <option *ngFor="let item of products" [value]="item.id">{{ item.name }}</option>
          </select>
        </label>
        <label>
          {{ 'product.componentType' | t }}
          <select [(ngModel)]="structureForm.componentTypeId">
            <option value="">{{ 'product.selectType' | t }}</option>
            <option *ngFor="let item of componentTypes" [value]="item.id">{{ item.name }}</option>
          </select>
        </label>
        <label>
          {{ 'product.quantity' | t }}
          <input type="number" min="1" [(ngModel)]="structureForm.quantity" />
        </label>
        <label>
          {{ 'product.order' | t }}
          <input type="number" min="1" [(ngModel)]="structureForm.orderNo" />
        </label>
      </div>
      <div class="actions">
        <button type="button" (click)="saveProductStructure()" [disabled]="busy">{{ structureForm.id ? ('product.updateStructure' | t) : ('product.createStructure' | t) }}</button>
        <button type="button" class="secondary" (click)="resetProductStructureForm()" [disabled]="busy">{{ 'common.clear' | t }}</button>
      </div>

      <div class="table-toolbar">
        <label>
          {{ 'common.filter' | t }}
          <input [(ngModel)]="tableState.productStructures.query" (ngModelChange)="onFilterChanged('productStructures')" [placeholder]="'product.searchStructures' | t" />
        </label>
        <label>
          {{ 'product.filter.product' | t }}
          <select [ngModel]="tableState.productStructures.facet" (ngModelChange)="tableState.productStructures.facet = $event; onFacetChanged('productStructures')">
            <option value="">{{ 'common.all' | t }}</option>
            <option *ngFor="let item of products" [value]="item.id">{{ item.name }}</option>
          </select>
        </label>
        <button type="button" class="secondary icon-button table-refresh" (click)="reloadData()" [disabled]="busy" [attr.aria-label]="'product.refresh.structures' | t" [title]="'product.refresh.structures' | t">&#10227;</button>
      </div>

      <table class="admin-table">
          <thead>
            <tr>
            <th class="sortable" (click)="toggleSort('productStructures', 'productName')">{{ 'product.product' | t }}<span class="sort-indicator">{{ sortIndicator('productStructures', 'productName') }}</span></th>
            <th class="sortable" (click)="toggleSort('productStructures', 'componentTypeName')">{{ 'product.componentType' | t }}<span class="sort-indicator">{{ sortIndicator('productStructures', 'componentTypeName') }}</span></th>
            <th class="sortable" (click)="toggleSort('productStructures', 'quantity')">{{ 'product.quantity' | t }}<span class="sort-indicator">{{ sortIndicator('productStructures', 'quantity') }}</span></th>
            <th class="sortable" (click)="toggleSort('productStructures', 'orderNo')">{{ 'product.order' | t }}<span class="sort-indicator">{{ sortIndicator('productStructures', 'orderNo') }}</span></th>
            <th class="action-col">{{ 'product.actions' | t }}</th>
            </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let item of pagedItems('productStructures')">
            <tr class="expandable-row" (click)="toggleRowExpansion('productStructures', item.id)">
              <td>{{ item.productName || '-' }}</td>
              <td>{{ item.componentTypeName || '-' }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.orderNo }}</td>
              <td class="row-actions action-col">
                <button type="button" class="secondary icon-button" (click)="$event.stopPropagation(); editProductStructure(item)" [disabled]="busy" [attr.aria-label]="'common.edit' | t" [title]="'common.edit' | t">&#9998;</button>
                <button type="button" class="danger icon-button" (click)="$event.stopPropagation(); deleteProductStructure(item)" [disabled]="busy" [attr.aria-label]="'common.delete' | t" [title]="'common.delete' | t"><svg class="icon-svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9 3h6l1 2h5v2H3V5h5l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM7 9h2v9H7V9z"/></svg></button>
              </td>
            </tr>
            <tr class="detail-row" *ngIf="isRowExpanded('productStructures', item.id)">
              <td colspan="5">
                <div class="audit-grid">
                  <span>{{ 'common.audit.ct' | t }}: {{ formatAuditTimestamp(item.ct) }}</span>
                  <span>{{ 'common.audit.mt' | t }}: {{ formatAuditTimestamp(item.mt) }}</span>
                  <span>{{ 'common.audit.cu' | t }}: {{ item.cu || '-' }}</span>
                  <span>{{ 'common.audit.mu' | t }}: {{ item.mu || '-' }}</span>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!visibleCount('productStructures')">
            <td colspan="5">{{ 'product.noStructures' | t }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pager">
        <span>{{ 'common.page' | t:{ page: tableState.productStructures.page, total: totalPages('productStructures'), items: visibleCount('productStructures') } }}</span>
        <div class="pager-controls">
          <label class="pager-size">
            {{ 'common.pageSize' | t }}
            <select [ngModel]="tableState.productStructures.pageSize" (ngModelChange)="setPageSize('productStructures', $event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="20">20</option>
              <option [value]="50">50</option>
            </select>
          </label>
          <div class="row-actions">
            <button type="button" class="secondary" (click)="previousPage('productStructures')" [disabled]="visibleCount('productStructures') === 0 || tableState.productStructures.page <= 1">{{ 'common.previous' | t }}</button>
            <button type="button" class="secondary" (click)="nextPage('productStructures')" [disabled]="visibleCount('productStructures') === 0 || tableState.productStructures.page >= totalPages('productStructures')">{{ 'common.next' | t }}</button>
          </div>
        </div>
      </div>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeSection === 'COMPATIBILITIES'">
    <section class="panel">
      <div class="panel-head">
        <h2>{{ 'product.compatibilities' | t }}</h2>
        <button
          type="button"
          class="secondary icon-button collapse-toggle"
          (click)="toggleCardCollapse('compatibilities')"
          [attr.aria-label]="isCardCollapsed('compatibilities') ? ('common.expand' | t) : ('common.collapse' | t)"
          [title]="isCardCollapsed('compatibilities') ? ('common.expand' | t) : ('common.collapse' | t)"
        >
          {{ isCardCollapsed('compatibilities') ? '+' : '-' }}
        </button>
      </div>
      <div *ngIf="!isCardCollapsed('compatibilities')">
      <div class="grid three">
        <label>
          {{ 'product.product' | t }}
          <select [(ngModel)]="compatibilityForm.productId">
            <option value="">{{ 'product.selectProduct' | t }}</option>
            <option *ngFor="let item of products" [value]="item.id">{{ item.name }}</option>
          </select>
        </label>
        <label>
          {{ 'product.component' | t }}
          <select [(ngModel)]="compatibilityForm.componentId">
            <option value="">{{ 'product.selectComponent' | t }}</option>
            <option *ngFor="let item of components" [value]="item.id">{{ item.name }}</option>
          </select>
        </label>
        <label>
          {{ 'product.required' | t }}
          <select [(ngModel)]="compatibilityForm.required">
            <option [ngValue]="true">{{ 'common.yes' | t }}</option>
            <option [ngValue]="false">{{ 'common.no' | t }}</option>
          </select>
        </label>
        <label>
          {{ 'product.default' | t }}
          <select [(ngModel)]="compatibilityForm.defaultSelected">
            <option [ngValue]="true">{{ 'common.yes' | t }}</option>
            <option [ngValue]="false">{{ 'common.no' | t }}</option>
          </select>
        </label>
      </div>
      <div class="actions">
        <button type="button" (click)="saveCompatibility()" [disabled]="busy">{{ compatibilityForm.id ? ('product.updateCompatibility' | t) : ('product.createCompatibility' | t) }}</button>
        <button type="button" class="secondary" (click)="resetCompatibilityForm()" [disabled]="busy">{{ 'common.clear' | t }}</button>
      </div>

      <div class="table-toolbar">
        <label>
          {{ 'common.filter' | t }}
          <input [(ngModel)]="tableState.compatibilities.query" (ngModelChange)="onFilterChanged('compatibilities')" [placeholder]="'product.searchCompatibilities' | t" />
        </label>
        <button type="button" class="secondary icon-button table-refresh" (click)="reloadData()" [disabled]="busy" [attr.aria-label]="'product.refresh.compatibilities' | t" [title]="'product.refresh.compatibilities' | t">&#10227;</button>
      </div>

      <table class="admin-table">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSort('compatibilities', 'productName')">{{ 'product.product' | t }}<span class="sort-indicator">{{ sortIndicator('compatibilities', 'productName') }}</span></th>
            <th class="sortable" (click)="toggleSort('compatibilities', 'componentName')">{{ 'product.component' | t }}<span class="sort-indicator">{{ sortIndicator('compatibilities', 'componentName') }}</span></th>
            <th class="sortable" (click)="toggleSort('compatibilities', 'required')">{{ 'product.required' | t }}<span class="sort-indicator">{{ sortIndicator('compatibilities', 'required') }}</span></th>
            <th class="sortable" (click)="toggleSort('compatibilities', 'defaultSelected')">{{ 'product.default' | t }}<span class="sort-indicator">{{ sortIndicator('compatibilities', 'defaultSelected') }}</span></th>
            <th class="action-col">{{ 'product.actions' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of pagedItems('compatibilities')">
            <tr class="expandable-row" (click)="toggleRowExpansion('compatibilities', item.id)">
              <td>{{ item.productName || '-' }}</td>
              <td>{{ item.componentName || '-' }}</td>
              <td>{{ item.required ? ('common.yes' | t) : ('common.no' | t) }}</td>
              <td>{{ item.defaultSelected ? ('common.yes' | t) : ('common.no' | t) }}</td>
              <td class="row-actions action-col">
                <button type="button" class="secondary icon-button" (click)="$event.stopPropagation(); editCompatibility(item)" [disabled]="busy" [attr.aria-label]="'common.edit' | t" [title]="'common.edit' | t">&#9998;</button>
                <button type="button" class="danger icon-button" (click)="$event.stopPropagation(); deleteCompatibility(item)" [disabled]="busy" [attr.aria-label]="'common.delete' | t" [title]="'common.delete' | t"><svg class="icon-svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M9 3h6l1 2h5v2H3V5h5l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM7 9h2v9H7V9z"/></svg></button>
              </td>
            </tr>
            <tr class="detail-row" *ngIf="isRowExpanded('compatibilities', item.id)">
              <td colspan="5">
                <div class="audit-grid">
                  <span>{{ 'common.audit.ct' | t }}: {{ formatAuditTimestamp(item.ct) }}</span>
                  <span>{{ 'common.audit.mt' | t }}: {{ formatAuditTimestamp(item.mt) }}</span>
                  <span>{{ 'common.audit.cu' | t }}: {{ item.cu || '-' }}</span>
                  <span>{{ 'common.audit.mu' | t }}: {{ item.mu || '-' }}</span>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!visibleCount('compatibilities')">
            <td colspan="5">{{ 'product.noCompatibilities' | t }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pager">
        <span>{{ 'common.page' | t:{ page: tableState.compatibilities.page, total: totalPages('compatibilities'), items: visibleCount('compatibilities') } }}</span>
        <div class="pager-controls">
          <label class="pager-size">
            {{ 'common.pageSize' | t }}
            <select [ngModel]="tableState.compatibilities.pageSize" (ngModelChange)="setPageSize('compatibilities', $event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="20">20</option>
              <option [value]="50">50</option>
            </select>
          </label>
          <div class="row-actions">
            <button type="button" class="secondary" (click)="previousPage('compatibilities')" [disabled]="visibleCount('compatibilities') === 0 || tableState.compatibilities.page <= 1">{{ 'common.previous' | t }}</button>
            <button type="button" class="secondary" (click)="nextPage('compatibilities')" [disabled]="visibleCount('compatibilities') === 0 || tableState.compatibilities.page >= totalPages('compatibilities')">{{ 'common.next' | t }}</button>
          </div>
        </div>
      </div>
      </div>
    </section>
  </ng-container>
</div>

<section class="panel" *ngIf="error">
  <p class="error">{{ error }}</p>
</section>

<section class="panel" *ngIf="info && !error">
  <p class="info">{{ info }}</p>
</section>

<div class="modal-backdrop" *ngIf="deleteDialogOpen">
  <section class="modal-panel">
    <h2>{{ deleteDialogTitle }}</h2>
    <p>{{ deleteDialogDescription }}</p>
    <p *ngIf="deleteDialogLoading">{{ 'common.loadingDependent' | t }}</p>
    <ng-container *ngIf="deleteDialogImpact && !deleteDialogLoading">
      <p *ngIf="!deleteDialogImpact.dependents.length">{{ 'common.noDependents' | t }}</p>
      <div *ngIf="deleteDialogImpact.dependents.length">
        <p>{{ 'common.dependentsWillDelete' | t }}</p>
        <ul class="dependent-list">
          <li *ngFor="let dependent of deleteDialogImpact.dependents">
            {{ formatDeleteDependent(dependent) }}
          </li>
        </ul>
      </div>
    </ng-container>
    <div class="actions">
      <button type="button" class="secondary" (click)="closeDeleteDialog()" [disabled]="deleteDialogLoading">{{ 'common.cancel' | t }}</button>
      <button type="button" class="danger" (click)="confirmDeleteFromDialog()" [disabled]="deleteDialogLoading">{{ 'common.confirmDelete' | t }}</button>
    </div>
  </section>
</div>

